import classedComponent from '../classedComponent';

const DropdownItemDivider = classedComponent('dropdown-divider');

export default DropdownItemDivider;
